import { useState, useEffect} from 'react';
import Barchart from '../Barchart';
import Doughnutchart from '../Doughnutchart';
import CustomTable from "../CustomTable"
import LineChart from './LineChart';


function FetchChartsAirportMonth({TimeOption, RegionIndicator, Time, MeasurementIndicator, AirportCodes, chartType, startDate, endDate}) {

    const [userData, setUserData] = useState([]);

    const [excelDataChart,setexcelDataChart] = useState([]);

    console.log("End Date", endDate)
    console.log("Start Date", startDate)

    let [start_month, start_year] = startDate.split("/");
    let [end_month, end_year] = endDate.split("/");

    if(start_month.charAt(0) === "0"){
        start_month = start_month.charAt(1)
    }

    if(end_month.charAt(0) === "0"){
        end_month = end_month.charAt(1)
    }


    useEffect(() => {
        fetch("api/get_indicator_by_month/", {method: "post", headers: {'Content-Type':'application/json'}, body:JSON.stringify({ ind_name: MeasurementIndicator, start_year: parseInt(start_year), end_year: parseInt(end_year), start_month: parseInt(start_month), end_month: parseInt(end_month) })}).then((res) =>
           res.json().then((res) => {

            console.log(res)

            const keys = Object.keys(res.data.data);
            
            

            const myObject = {};
            AirportCodes.forEach((key) => {
              myObject[key] = [];
            });


            keys.forEach((date, i) => {
                let airports = Object.keys(res.data.data[date])
                
                airports.forEach((airport, j) =>{

                    
                    const str = JSON.stringify(airport);
                    const code2 = str.slice(-5,-2)

                    if(AirportCodes.includes(code2)) {
                       
                        myObject[code2].push(res.data.data[date][airport])
                    

                    }
                })   
            })
            
            
            let  Fin_list = []
            let exceldata = []

            let fin_keys = Object.keys(myObject)

            for(let i = 0; i < fin_keys.length; i++){
                let randomColor = '#' + Math.floor(Math.random()*16777215).toString(16);

                Fin_list.push({
                    label: fin_keys[i],
                    data: myObject[fin_keys[i]],
                    backgroundColor: randomColor,
                    barPercentage: 0.8,
                    categoryPercentage: 0.5,
                })

                //set excel data
                for(let j = 0; j < myObject[fin_keys[i]].length; j++){
                    exceldata.push({"Αεροδρόμιο": fin_keys[i], "Τιμή": myObject[fin_keys[i]][j], "Μήνας": keys[j]})
                }

            }

            
   
            setUserData({
                labels: keys,
                datasets: Fin_list
                })


            
            setexcelDataChart(exceldata)


           
          })
        )
        .catch((error) => {
          console.log("Refetching data for airport info!")
        });
      }, [MeasurementIndicator,AirportCodes, start_month, start_year, end_month, end_year]);
    



    let component;

    
    if(userData.length !== 0){
        switch (chartType) {
            case 0:
                let BarChartoptions = {
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        legend: {
                        position: 'bottom',
                        },
                    },
                    scales: {
                        y: {
                        suggestedMin: 0,
                        },
                    }
                }
                
                component = <Barchart chartData={userData} chartOptions = {BarChartoptions} excelData ={excelDataChart}> </Barchart>
           
            break;
            case 1:

                let Doughnutchartoptions = {maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                    legend: {
                        position: 'right',
                    },
                    }
                }
                component = <Doughnutchart chartData={userData} chartOptions ={Doughnutchartoptions} excelData = {excelDataChart} ></Doughnutchart>
           
            
            break;
            case 2:
               
                    component = <CustomTable data = {excelDataChart}></CustomTable>
                
            
            break;
        
            case 3:

            let LineChartoptions = {
                maintainAspectRatio: false,
                responsive: true,
                plugins: {
                  legend : {
                   display: false,
                  }
                }
              }
            
              component = <LineChart chartData={userData} chartOptions = {LineChartoptions} excelData ={excelDataChart}></LineChart>
            
            break;
            default:
            component = <h1>Παρακαλώ επιλέξτε τύπο διαγράμματος</h1>;
        }
       
        
        return (
            <div className="container filters-wrapper" style = {{marginTop: "5%"}}>
                <div style = {{display: "flex", marginTop: "3%"}}>
                    <div>
                        <p>Επιλεγμένη χρονική περίοδος</p>
                        <p><strong>{TimeOption}</strong></p>
                    </div>
                    <div style = {{marginLeft: "25%"}}>
                        <p>Επιλεγμένος δείκτης μέτρησης</p>
                        <p><strong>{RegionIndicator}</strong></p>
                    </div>
                </div>
                <div style = {{display: "flex"}}>
                    <div>
                        <p>Επιλεγμένη περίοδος</p>
                        <p><strong>{startDate} - {endDate}</strong></p>
                    </div>
                    <div style = {{marginLeft: "32%"}}>
                        <p>Επιλεγμένοι δείκτες</p>
                        <p><strong>{MeasurementIndicator}</strong></p>
                    </div>

                </div>

                
                {component}
            
            </div>
        );
    }
    else {
        return (<></>)
    }
}

export default FetchChartsAirportMonth;
